// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {Fragment} from 'react';
import styles from './index.module.less';
import {Button} from '../../../../hola/pub/lib/button';
import Icon_arrow_right from '../../../../hola/pub/img/hola2023/icons/24/arrow_right.svg';
import {perr} from 'hola_pub_util';
import {use_translation_v} from '../../../../hola/pub/lib/trans_v';
import {use_show_promo} from '../../ui/free_proxy/use_show_promo';
import {Editor} from '../../../../shared/editor/editor';
import {Dynamic_heading} from '../../../../shared/editor/title_header_select';

interface I_hp_final_props {
    title?: string;
    title_tag?:string;
    caption?: string;
    to?: string;
}

export const HP_final = (props: I_hp_final_props)=>{
    const {T} = use_translation_v({no_defaults: true});
    const {show_promo} = use_show_promo();
    const title = props.title || 'Get the right Proxies.<br/>Get ahead.';
    const caption = props.caption || (show_promo ? 'Get started' : 'Try now');
    const to = props.to || '/dashboard';
    return <div className={styles.hp_final}>
      <div className={styles.bg}/>
      <div className={styles.container}>
        <Dynamic_heading tag={props.title_tag || 'h2'}>
          <T>{title}</T>
        </Dynamic_heading>
        <Button
          caption={<Fragment><T>{caption}</T> <Icon_arrow_right/></Fragment>}
          size={'lg'} no_jump cls={styles.last_btn} to={to} fit
          round={false} on_click={()=>{
            perr({id: 'toolip_homepage_get_started_bottom_click'});
          }}/>
      </div>
    </div>;
};

interface i_hp_final_editor_value {
    title: string;
    caption: string;
    to: string;
}

interface i_hp_final_editor_props {
    value?: i_hp_final_editor_value;
    on_change: (value: i_hp_final_editor_value)=>void;
}

export const HP_final_editor = (props: i_hp_final_editor_props)=>{
    const {value = {title: '', caption: '', to: ''}, on_change} = props;
    type editor_key = keyof i_hp_final_editor_value;
    type editor_type = 'text' | 'textarea' | 'number' | 'boolean' | 'selector'
      | 'select_tag_selector';
    const editors = [
        ['title', 'Title', 'text'],
        ['title_tag', 'Title Tag', 'select_tag_selector'],
        ['caption', 'Button Caption', 'text'],
        ['to', 'Button Link', 'text']
    ].map(([key, label, type])=>({key: key as editor_key, label,
        type: type as editor_type}));
    return <Editor
      value={value}
      editors={editors}
      on_change={on_change}
      title="HP Final Editor"
    />;
};
